<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">END LIVE 상세</div>
                    <post-detail-component :postType="'endLiveDetail'" :postKey="postKey"></post-detail-component>
                    <div class="pa20 text_center">
                        <el-button @click="$router.back()">목록</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostDetailComponent from "@/components/post/PostDetailComponent";
import EventBus from "@/utils/event-bus";

export default {
    name: "EndLiveDetail",
    mixins: [],
    components: {
        PostDetailComponent
    },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            postKey: Number(this.$route.params.wr_id),
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        runDelete() {
            EventBus.$emit('deleteElastic', this.postKey);
        },
    },
    watch: {},
}
</script>
